$(document).ready(function () {
    refreshCart(false)

    $('#async-popup-cart .ymal-header').height($('async-popup-cart .cart-header').height());

    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('cart') && urlParams.get('cart') === 'open') {
        openCart();
    }
});

$(window).on('resize', function(){
    $('#async-popup-cart .ymal-header').height($('async-popup-cart .cart-header').height());
});

// open cart on navigation
$('.async-header .nav-cart').on('click', function() {
    openCart();
});

$('.async-header .nav-cart').on('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        $(this).trigger('click');
    }
});

function openCart() {
    $('#async-popup-cart').css('display', 'flex');

    if ($('#async-popup-cart').find('.cart-body').find('.product').length == 0) 
        $('#async-popup-cart .ymal').css('right', '-100%');

    $('body').css('overflow-y', 'hidden');
}

// close cart
$('#async-popup-cart .cart-close').on('click', function() {
    closeCart();
});

function closeCart() {
    $('#async-popup-cart').css('display', 'none');

    $('body').css('overflow-y', 'visible');
}

// preventing scroll
function preventScroll(event) {
    event.preventDefault();
}

// form add to cart
$('.atc-form').on('submit', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            openCart();
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    }).done(function() {
        refreshCart(false);
    });
});

// ymal add to cart
$('.ymal-form').on('submit', function (event) {
    event.preventDefault();
    let formData = $(this).serialize();

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function () {
            refreshCart(true);
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
        }
    });
});

// item remove to cart
$(document).on('click', '.product-remove', function(event) {
    event.preventDefault();

    let removeUrl = $(this).attr('href'); 

    $.ajax({
        type: 'POST',
        url: removeUrl,
        success: function() {
            refreshCart(false);
        },
        error: function(xhr, status, error) {
            console.error('Error removing item:', error);
        }
    });
});

// update quantity
var qtyTimer;
function updateQty(updateUrl) {
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function() {
        $.ajax({
            type: 'POST',
            url: updateUrl,
            success: function() {
                refreshCart(false);
            },
            error: function(xhr, status, error) {
                console.error('Error updating item:', error);
            }
        });
    }, 300);
}
$(document).on('click', '#async-popup-cart .less_qty', function() {
    let key = $(this).data('key');
    let qty = $(`#async-popup-cart .qty[data-key="${key}"]`).val();

    if (qty > 1) {
        qty--;

        let updateUrl = `/cart/change?id=${key}&quantity=${qty}`;

        $(`#async-popup-cart .qty[data-key="${key}"]`).val(qty);

        updateQty(updateUrl);
    }
});
$(document).on('click', '#async-popup-cart .add_qty', function() {
    let key = $(this).data('key');
    let qty = $(`#async-popup-cart .qty[data-key="${key}"]`).val();

    if (qty < 100) {
        qty++;

        let updateUrl = `/cart/change?id=${key}&quantity=${qty}`;
        
        $(`#async-popup-cart .qty[data-key="${key}"]`).val(qty);

        updateQty(updateUrl);
    }
});

// show added on ymal
function showAdded() {
    $('#async-popup-cart #ymal-overlay').css('display', 'block');
    setTimeout(function() {
        $('#async-popup-cart #ymal-overlay').css('opacity', '0');
    }, 1000);

    $('#async-popup-cart #ymal-overlay').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
        $('#async-popup-cart #ymal-overlay').css({
            'display': 'none',
            'opacity': '1'
        });
    });
}

// show options
$(document).on('click', '.btn-ymal.qv', function(e) {
    let id = $(this).data('ymal-id');
    
    $(`#async-popup-cart .option`).css('right', '-100%');
    $(`#async-popup-cart .option[data-option-id="${id}"]`).css('right', '0');
    $(`#async-popup-cart .option .ymal-qty`).val(1);
});

// close option
$('#async-popup-cart .option-close').on('click', function() {
    $('#async-popup-cart .option').css('right', '-100%');
});

// submit ymal atc
$(document).on('click', '#async-popup-cart .btn-ymal.add', function() {
    let form = $(this).parent().attr('id');
    $(`form#${form}`).submit();
});

// refresh cart
function refreshCart(ymal) {
    
    $('#async-popup-cart .el-overlay').show();
    $('#async-popup-cart .option').css('right', '-100%');

    $.ajax({
        type: 'GET',
        url: window.location.href,
        dataType: 'html',
        success: function(cartHtml) {
            let newCartItems = $(cartHtml).find('.cart-body').html();
            $('#async-popup-cart .cart-body').html(newCartItems);

            let newCartTotal = $(cartHtml).find('.cart-total-price').html();
            $('#async-popup-cart .cart-total-price').html(newCartTotal);

            if ($(cartHtml).find('.cart-body').find('.product').length == 0) {
                $('#async-popup-cart .btn-atc').addClass('disabled');

                $('#async-popup-cart .ymal-body').html('');
                $('#async-popup-cart .ymal').css('right', '-100%')

                $('#async-popup-cart .ymal-mobile').css('display', 'none');
            }
            else
                $('#async-popup-cart .btn-atc').removeClass('disabled');

            $('#async-popup-cart .el-overlay').hide();

            if (ymal) {
                showAdded();
            }

            // update recommended list for desktop
            $('#async-popup-cart .ymal .ymal-hidden').find('.product').removeClass('recommended');
            $('#async-popup-cart .ymal .ymal-hidden').find('.product').removeClass('added');

            $(cartHtml).find('.cart-body .product-main-title').each(function(index, element) {
                let product_title = $(element).text().trim();
                
                ymalList_desktop(product_title);
            });

            // update recommended list for mobile
            $('#async-popup-cart .cart .ymal-mobile-hidden').find('.product').removeClass('recommended');
            $('#async-popup-cart .cart .ymal-mobile-hidden').find('.product').removeClass('added');

            $(cartHtml).find('.cart-body .product-main-title').each(function(index, element) {
                let product_title = $(element).text().trim();
                
                ymalList_mobile(product_title);
            });
        },
        error: function(xhr, status, error) {
            console.error('Error fetching cart data:', error);
            $('#async-popup-cart .el-overlay').hide();
        }
    });
}

// ymal desktop
function ymalList_desktop(product_title) {
    let container = $('#async-popup-cart .ymal .ymal-hidden');
    let count = container.find('.product').filter(function() {
        return $(this).data('for-product').toLowerCase().includes(product_title.toLowerCase());
    }).length;

    // add added class if atc
    container.find('.product').filter(function() {
       return $(this).find('.product-title').text().trim().toLowerCase() == product_title.toLowerCase();
    }).addClass('added');

    if (count > 0) {
        // add recommened class
        container.find('.product').filter(function() {
            return $(this).data('for-product').toLowerCase().includes(product_title.toLowerCase());
        }).addClass('recommended');
    }

    // add list to ymal
    let items = $('#async-popup-cart .ymal-hidden .product.recommended:not(.added)');
    let body = $('#async-popup-cart .ymal-body');
    body.html('');
    items.clone().appendTo(body);

    // ymal open close
    if ($('#async-popup-cart .ymal-body').find('.product').length > 0) {
        $('#async-popup-cart .ymal').css('right', '0');
    }
    else {
        $('#async-popup-cart .ymal').css('right', '-100%');
    }
}

// ymal desktop
function ymalList_mobile(product_title) {
    $('#async-popup-cart .ymal-mobile .owl-carousel').trigger('destroy.owl.carousel');
    $('#async-popup-cart .ymal-mobile .owl-carousel').html('');

    let container = $('#async-popup-cart .cart .ymal-mobile-hidden');
    let count = container.find('.product').filter(function() {
        return $(this).data('for-product').toLowerCase().includes(product_title.toLowerCase());
    }).length;

    // add added class if atc
    container.find('.product').filter(function() {
       return $(this).find('.product-title').text().trim().toLowerCase() == product_title.toLowerCase();
    }).addClass('added');

    if (count > 0) {
        // add recommened class
        container.find('.product').filter(function() {
            return $(this).data('for-product').toLowerCase().includes(product_title.toLowerCase());
        }).addClass('recommended');
    }

    // add list to ymal
    let items = $('#async-popup-cart .ymal-mobile-hidden .item:has(.product.recommended:not(.added))');
    if (items.length > 0) {
        let body = $('#async-popup-cart .ymal-mobile .owl-carousel');
        body.html('');
        items.clone().appendTo(body);

        setTimeout(() => {
            $("#async-popup-cart .ymal-mobile .owl-carousel").owlCarousel({
                items: 2,
                dots: true,
                margin: 15,
                smartSpeed: 500,
                responsive: {
                    0 : {
                        items: 1,
                    },
                    768 : {
                        items: 2,
                    }
                }
            });
        }, 10);
    }

    // ymal open close
    if ($('#async-popup-cart .ymal-mobile .owl-carousel').find('.item').length > 0) {
        $('#async-popup-cart .ymal-mobile').css('display', 'block');
    }
    else {
        $('#async-popup-cart .ymal-mobile').css('display', 'none');
    }
}

// close if away
$(document).on('click', function (event) {
    if ($('#async-popup-cart').css('display') == 'flex' && !$(event.target).closest('.ymal, .cart, .option').length && !$(event.target).hasClass('nav-cart')) {
        closeCart();
    }
});
